export { ThumbsNavigation } from './ThumbsNavigation';
